import { Injectable } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { ToastController } from '@ionic/angular';

import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AppUpdaterService {

  constructor(
    private updates: SwUpdate,
    private toastCtrl: ToastController
  ) { }

  public checkForUpdates(): void {
    this.updates.versionUpdates
      .pipe(filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'),
        map(evt => ({
          type: 'UPDATE_AVAILABLE',
          current: evt.currentVersion,
          available: evt.latestVersion,
        })))
      .subscribe(evt => {
        this.promptUser(evt.available);
      });
  }

  private async promptUser(available) {
    const toast = await this.toastCtrl.create({
      message: 'Update available!',
      position: 'bottom',
      buttons: [
        {
          role: 'cancel',
          text: 'Reload'
        }
      ]
    });

    await toast.present();

    toast
      .onDidDismiss()
      .then(() => this.updates.activateUpdate())
      .then(() => window.location.reload());
  }
}
